import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

// Models
import { EntityModel } from '@app/models/entity.model';

// Services
import { EntityLookupModel } from '@app/models/entity-lookup.model';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class EntityService {
  private readonly apiService = inject(ApiService);

  findEntityByDnb(dnbId: string): Observable<EntityLookupModel> {
    const resourceUrl = `entities/findByDnBandSave/${dnbId}`;

    return this.apiService.post<EntityLookupModel>(resourceUrl, {});
  }

  findCompanyMatches(companyName: string, countryCode?: string, domain?: string): Observable<EntityModel[]> {
    const resourceUrl = 'entities/companySearch';
    return this.apiService.post<EntityModel[]>(
      resourceUrl,
      JSON.stringify({
        companyName,
        countryCode,
        domain,
      }),
    );
  }
}
